import axios from "axios"

// Custom Component
// import DoRefreshToken from '../components/SignIn/DoRefreshToken'
import SignOut from '../components/SignIn/SignOut'

const store = require('store')

const saveAnnotation = async (annotationData) => {
	const saveAnnotation_api = "/annotation"
	let headers
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'post',
			url: process.env.REACT_APP_API_URL_3002 + saveAnnotation_api,
			headers: headers,
			data: annotationData
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getAnnotation = async (fileData) => {
	const getAnnotation_api = "/annotation"
	let headers
	let result
	
	try {
		headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3002 + getAnnotation_api,
			headers: headers,
			params: fileData
		})

		return result.data
		
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


export {
	saveAnnotation,
	getAnnotation
}